import { useState } from 'react';
import useAgronomistList from 'hooks/useAgronomistList';
import useSubDistrictList from 'hooks/useSubDistrictList';

export enum PaymentStatus {
  'PAID' = 'paid',
  'UNPAID' = 'sent',
  'PARTIALLY_PAID' = 'partially_paid',
  'OVERDUE' = 'overdue',
}

const formatLabel = (status: string) => {
  if (status === 'sent') {
    return 'Unpaid';
  }
  return status
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w|\s\w/g, (c) => c.toUpperCase());
};

const paymentStatusFilterOptions = Object.values(PaymentStatus).map(
  (status) => ({
    value: status,
    label: formatLabel(status),
  }),
);

const useInvoiceFilters = (country: string) => {
  const [searchedInvoice, setSearchedInvoice] = useState<string>();
  const [invoice, setInvoice] = useState<string | null>(null);
  const [estHarvestDateRange, setEstHarvestDateRange] = useState<
    [string, string] | null
  >(null);
  const [paymentStatus, setPaymentStatus] = useState<PaymentStatus | null>(
    null,
  );
  const [agronomist, setAgronomist] = useState<any[]>([]);
  const [subDistrict, setSubDistrict] = useState<any[]>([]);

  const { isLoading: isAgronomistListLoading, agronomistFilterOptions } =
    useAgronomistList(country);

  const { subDistrictOptions, isLoading: isSubDistrictLoading } =
    useSubDistrictList(country);

  const resetTableFilters = () => {
    setSearchedInvoice(undefined);
    setEstHarvestDateRange(null);
    setInvoice(null);
    setPaymentStatus(null);
    setAgronomist([]);
    setSubDistrict([]);
  };

  return {
    currentSearchedInvoice: searchedInvoice,
    setCurrentSearchedInvoice: setSearchedInvoice,
    currentInvoice: invoice,
    setCurrentInvoice: setInvoice,
    estHarvestDateRange,
    setEstHarvestDateRange,
    paymentStatusFilterOptions,
    currentPaymentStatus: paymentStatus,
    setCurrentPaymentStatus: setPaymentStatus,
    agronomistFilterOptions,
    isAgronomistListLoading,
    currentAgronomist: agronomist,
    setCurrentAgronomist: setAgronomist,
    isSubDistrictLoading,
    subDistrictOptions,
    currentSubDistrict: subDistrict,
    setCurrentSubDistrict: setSubDistrict,
    resetTableFilters,
  };
};

export default useInvoiceFilters;
